import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.dropbox-provisioning', {
        url: '/dropbox-provisioning',
        component: 'companyManageApplicationDropboxProvisioning',
        resolve: {
            dropboxConfigurationDTO,
        },
    });
}

function dropboxConfigurationDTO(appId, companyId, DropboxProvisioningService) {
    return DropboxProvisioningService.provisioningConfiguration.get({companyId, appId}).$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning.state.js